export const ServicesWrapper = 'flex flex-col justify-center gap-3 pt-6'
export const ServicesLink = 'flex flex-row justify-between items-center'
